module.exports = __webpack_public_path__ + "img/wochenblatt-rheno-palatia.1955c87c.jpg";